import { supabase } from '@/integrations/supabase/client';
import { useUserStore } from '@/store/userStore';

/**
 * ✅ VERSION SYNCHRONE : Récupère le gym_id actuellement sélectionné depuis le userStore
 * À utiliser dans TOUS les stores React
 * @returns The gym_id currently selected by the user, or null if none selected
 */
export function getUserGymId(): string | null {
  const gymId = useUserStore.getState().gymId;
  return gymId;
}

/**
 * ✅ Récupère TOUS les gym_ids accessibles par l'utilisateur
 * @returns Array of gym_ids accessible by the user
 */
export function getUserAvailableGymIds(): string[] {
  const availableGyms = useUserStore.getState().availableGyms;
  return availableGyms.map(g => g.id);
}

/**
 * ✅ VERSION ASYNC : Pour les edge functions ou contextes où le store n'est pas disponible
 * Uniquement utilisée dans les edge functions Supabase
 * @throws Error if user is not authenticated or has no gym assigned
 * @returns The primary gym_id of the current user
 */
export async function fetchUserGymId(): Promise<string> {
  const { data: { user } } = await supabase.auth.getUser();
  
  if (!user) {
    throw new Error('Not authenticated');
  }
  
  const { data: assignment, error } = await supabase
    .from('user_gym_assignments')
    .select('gym_id')
    .eq('user_id', user.id)
    .eq('is_primary_gym', true)
    .single();
  
  if (error) {
    throw error;
  }
  
  if (!assignment?.gym_id) {
    throw new Error('User has no gym assigned');
  }
  
  return assignment.gym_id;
}
